import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

/**
 * Unified Chart Tooltip Component
 * Provides consistent styling for Recharts tooltips across all calculators
 *
 * Usage:
 * <Tooltip content={<ChartTooltip header="Month 12" rows={[...]} summary="..." />} />
 */
const ChartTooltip = ({ header, rows, summary, children }) => {
  // If using children render prop pattern
  if (children) {
    return <div className={styles.tooltip}>{children}</div>;
  }

  // If using structured props pattern
  return (
    <div className={styles.tooltip}>
      {header && <p className={styles.tooltip_header}>{header}</p>}
      {rows &&
        rows.map((row, index) => (
          <p key={index} className={`${styles.tooltip_row} ${row.className || ''}`}>
            {row.label && <span className={styles.tooltip_label}>{row.label}: </span>}
            {row.value}
          </p>
        ))}
      {summary && <p className={styles.tooltip_summary}>{summary}</p>}
    </div>
  );
};

ChartTooltip.propTypes = {
  // Header text (e.g., "Month 12" or "Year 3")
  header: PropTypes.string,

  // Array of row objects: { label: string, value: string, className: string }
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.node,
      className: PropTypes.string
    })
  ),

  // Summary text at bottom (optional)
  summary: PropTypes.string,

  // Children for custom content (alternative to structured props)
  children: PropTypes.node
};

export default ChartTooltip;
